import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "../languages/en/translation.json";
import translationRU from "../languages/ru/translation.json";
import translationAM from "../languages/am/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  ru: {
    translation: translationRU,
  },
  am: {
    translation: translationAM,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
